import { render } from "./Title.vue?vue&type=template&id=e1ef82c0&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=e1ef82c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1ef82c0"

export default script